import React from "react";
import "./Documents.css";

const documents = [
  {
    title: "Proof of Job Offer Letter",
    badge: "Confidential",
    image: "images/job.png",
    description:
      "A comprehensive report highlighting my qualifications and presenting a strong case for my suitability for the position.",
    file: "scatec.pdf",
  },
  {
    title: "Job Cover Letter",
    badge: "Document",
    image: "images/jcl.png",
    description:
      "A detailed report on my qualifications and why I am a strong candidate for the position.",
    file: "JOB-LETTER-SA-NTLANGANISO-2024.pdf",
  },
  {
    title: "Resume",
    badge: "CV",
    image: "images/e.png",
    description:
      "A comprehensive overview of my professional experiences, education, skills, and accomplishments.",
    file: "cv.pdf",
  },
  {
    title: "Academic Record",
    badge: "Academic",
    image: "images/A.png",
    description:
      "Official academic transcript reflecting my completed coursework and performance.",
    file: "Academic.pdf",
  },
  {
    title: "South African ID Document",
    badge: "Identification",
    image: "images/id.webp",
    description:
      "Official identification document for verification purposes.",
    file: "id.pdf",
  },
  {
    title: "AWS Cloud Certificate",
    badge: "Certification",
    image: "images/aws_p.png",
    description:
      "AWS certification demonstrating knowledge of cloud infrastructure, deployment, and core AWS services.",
    file: "aws_c.pdf",
  },
  {
    title: "Google Cloud AI Certificate",
    badge: "Certification",
    image: "images/gg.png",
    description:
      "AI Introduction Course by Google Cloud on Coursera — covers Machine Learning and Deep Learning fundamentals.",
    link: "https://coursera.org/verify/M4PY4SC5UA2F",
    file: "Coursera-AI-Introduction-certificate.pdf",
  },
  {
    title: "CompTIA A+ Certificate",
    badge: "Certification",
    image: "images/coo.png",
    description:
      "CompTIA A+ certification reflecting proficiency in IT fundamentals, hardware, and troubleshooting.",
    file: "CompTIA-A-Certificate.pdf",
  },
];

const DocumentsPage = () => (
  <div className="content">
    <div className="page-header">
      <p className="page-eyebrow">Portfolio</p>
      <h2>Documents</h2>
      <p className="page-subtitle">
        Credentials, certifications & professional documents
      </p>
    </div>

    <div className="documents-container">
      {documents.map((doc, index) => (
        <div className="document-box" key={index}>
          <div className="doc-image-wrap">
            <img src={doc.image} alt={`${doc.title} thumbnail`} />
          </div>

          <div className="doc-body">
            <header>
              <h3>{doc.title}</h3>
              {doc.badge && <span className="doc-badge">{doc.badge}</span>}
              <p className="document-description">{doc.description}</p>
            </header>

            {doc.link ? (
              <a
                href={doc.link}
                className="doc-action"
                target="_blank"
                rel="noopener noreferrer"
              >
                View Certificate ↗
              </a>
            ) : (
              <a href={`/docs/${doc.file}`} className="doc-action" download>
                Download ↓
              </a>
            )}
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default DocumentsPage;